const RoleEnum = {
  Admin: {
    id: 1,
    name: "Admin",
  },
  OfficeStaff: {
    id: 4,
    name: "Office Staff",
  },
  Technician: {
    id: 5,
    name: "Technician",
  },
  Sales: {
    id: 6,
    name: "Sales",
  },
};
export default RoleEnum;
